export const typeToAPI = {
  'institutional': 'accounts/institutionalAccount',
  'non-gc': 'accounts/nonGCAccount',
  'annuity': 'annuity',
  'pension': 'pension',
}
